import { render, staticRenderFns } from "./IdentificationError.vue?vue&type=template&id=58748887&scoped=true"
import script from "./IdentificationError.vue?vue&type=script&lang=js"
export * from "./IdentificationError.vue?vue&type=script&lang=js"
import style0 from "./IdentificationError.vue?vue&type=style&index=0&id=58748887&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58748887",
  null
  
)

export default component.exports